import { stories } from '../firebase/Collections';
import { FieldValue } from '../firebase/Settings';

const random = () => {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
}
export const newStoryObj = (title, user) => {
    return {
        title: title,
        author: user.displayName === null ? 'Anonymous' : user.displayName,
        text: [],
        contributors: [],
        authorID: user.uid,
        tags: [],
        id: random()
    }
}
export const createNewStory = (data, handleOpen) => {
    stories.doc(data.id).set(data)
        .then(() => {
            handleOpen()
        })
        .catch((err) => {
            console.log(err.message);
        })
}
export const newStoryTextObj = (user, fontFamily, newWords) => {
    return {
        contributor: user.displayName,
        fontFamily: fontFamily,
        words: newWords,
        contributorID: user.uid
    }
}
export const getStoryList = (setStoryList) => {
    stories.onSnapshot((snapshot) => {
        let list = []
        snapshot.forEach((doc) => {
            list.push(doc.data())
        })
        setStoryList(list)
    }, (err) => console.log(err.message))
}
export const addFiveNewWords = (story, data, handleOpen) => {
    stories.doc(story.id).update({
        contributors: story.contributors.concat(data.contributorID),
        text: FieldValue.arrayUnion(data)
    })
        .then(() => {
            handleOpen()
        })
        .catch((err) => {
            console.log(err.message);
        })
}
export const followStory = (id, setState, state) => {
    stories.doc(id).onSnapshot((doc) => {
        setState({
            ...state,
            currentStory: doc.data()
        })
    }, (err) => console.log(err.message))
}
export const selectStory = (story, state, setState, history) => {
    if (state.user.uid !== undefined) {
        setState({
            ...state,
            currentStory: story
        });
        history.push('/storyPage')
    } else {
        window.alert("Only logged in users can edit stories. Please create an account or sign in anonymously.")
    }
}